<template>
  <div id="app">
    <rwv-header></rwv-header>
    <router-view/>
    <rwv-footer></rwv-footer>
  </div>
</template>
<script>
import * as $ from 'jquery'
import 'paroller.js';
//import flex from './assets/js/jquery.flexverticalcenter.js';
//import './assets/js/jquery.matchHeight-min.js';

import RwvHeader from '@/components/Header'
import RwvFooter from '@/components/Footer'
export default {
  name: 'App',
  components: {
    RwvHeader,
    RwvFooter
  },
  mounted() {
    $.fn.easeScroll = function(options) {
      ! function() {
        function e() {
          var e = !1;
          e && c("keydown", r), v.keyboardSupport && !e && u("keydown", r)
        }

        function t() {
          if (document.body) {
            var t = document.body,
              o = document.documentElement,
              n = window.innerHeight,
              r = t.scrollHeight;
            if (S = document.compatMode.indexOf("CSS") >= 0 ? o : t, w = t, e(), x = !0, top != self) y = !0;
            else if (r > n && (t.offsetHeight <= n || o.offsetHeight <= n)) {
              var a = !1,
                i = function() {
                  a || o.scrollHeight == document.height || (a = !0, setTimeout(function() {
                    o.style.height = document.height + "px", a = !1
                  }, 100))
                };
              if (o.style.height = "auto", setTimeout(i, 10), S.offsetHeight <= n) {
                var l = document.createElement("div");
                l.style.clear = "both", t.appendChild(l)
              }
            }
            v.fixedBackground || b || (t.style.backgroundAttachment = "scroll", o.style.backgroundAttachment = "scroll")
          }
        }

        function o(e, t, o, n) {
          if (n || (n = 1e3), d(t, o), 1 != v.accelerationMax) {
            var r = +new Date,
              a = r - C;
            if (a < v.accelerationDelta) {
              var i = (1 + 30 / a) / 2;
              i > 1 && (i = Math.min(i, v.accelerationMax), t *= i, o *= i)
            }
            C = +new Date
          }
          if (M.push({
              x: t,
              y: o,
              lastX: 0 > t ? .99 : -.99,
              lastY: 0 > o ? .99 : -.99,
              start: +new Date
            }), !T) {
            var l = e === document.body,
              u = function() {
                for (var r = +new Date, a = 0, i = 0, c = 0; c < M.length; c++) {
                  var s = M[c],
                    d = r - s.start,
                    f = d >= v.animationTime,
                    h = f ? 1 : d / v.animationTime;
                  v.pulseAlgorithm && (h = p(h));
                  var m = s.x * h - s.lastX >> 0,
                    w = s.y * h - s.lastY >> 0;
                  a += m, i += w, s.lastX += m, s.lastY += w, f && (M.splice(c, 1), c--)
                }
                l ? window.scrollBy(a, i) : (a && (e.scrollLeft += a), i && (e.scrollTop += i)), t || o || (M = []), M.length ? E(u, e, n / v.frameRate + 1) : T = !1
              };
            E(u, e, 0), T = !0
          }
        }

        function n(e) {
          x || t();
          var n = e.target,
            r = l(n);
          if (!r || e.defaultPrevented || s(w, "embed") || s(n, "embed") && /\.pdf/i.test(n.src)) return !0;
          var a = e.wheelDeltaX || 0,
            i = e.wheelDeltaY || 0;
          return a || i || (i = e.wheelDelta || 0), !v.touchpadSupport && f(i) ? !0 : (Math.abs(a) > 1.2 && (a *= v.stepSize / 120), Math.abs(i) > 1.2 && (i *= v.stepSize / 120), o(r, -a, -i), void e.preventDefault())
        }

        function r(e) {
          var t = e.target,
            n = e.ctrlKey || e.altKey || e.metaKey || e.shiftKey && e.keyCode !== H.spacebar;
          if (/input|textarea|select|embed/i.test(t.nodeName) || t.isContentEditable || e.defaultPrevented || n) return !0;
          if (s(t, "button") && e.keyCode === H.spacebar) return !0;
          var r, a = 0,
            i = 0,
            u = l(w),
            c = u.clientHeight;
          switch (u == document.body && (c = window.innerHeight), e.keyCode) {
            case H.up:
              i = -v.arrowScroll;
              break;
            case H.down:
              i = v.arrowScroll;
              break;
            case H.spacebar:
              r = e.shiftKey ? 1 : -1, i = -r * c * .9;
              break;
            case H.pageup:
              i = .9 * -c;
              break;
            case H.pagedown:
              i = .9 * c;
              break;
            case H.home:
              i = -u.scrollTop;
              break;
            case H.end:
              var d = u.scrollHeight - u.scrollTop - c;
              i = d > 0 ? d + 10 : 0;
              break;
            case H.left:
              a = -v.arrowScroll;
              break;
            case H.right:
              a = v.arrowScroll;
              break;
            default:
              return !0
          }
          o(u, a, i), e.preventDefault()
        }

        function a(e) {
          w = e.target
        }

        function i(e, t) {
          for (var o = e.length; o--;) z[N(e[o])] = t;
          return t
        }

        function l(e) {
          var t = [],
            o = S.scrollHeight,
            overflow = getComputedStyle(e, "").getPropertyValue("overflow-y");
          do {
            var n = z[N(e)];
            if (n) return i(t, n);
            if (t.push(e), o === e.scrollHeight) {
              if (!y || S.clientHeight + 10 < o) return i(t, document.body)
            } else if (e.clientHeight + 10 < e.scrollHeight && (overflow = getComputedStyle(e, "").getPropertyValue("overflow-y"), "scroll" === overflow || "auto" === overflow)) return i(t, e)
          } while (e = e.parentNode)
        }

        function u(e, t, o) {
          window.addEventListener(e, t, o || !1)
        }

        function c(e, t, o) {
          window.removeEventListener(e, t, o || !1)
        }

        function s(e, t) {
          return (e.nodeName || "").toLowerCase() === t.toLowerCase()
        }

        function d(e, t) {
          e = e > 0 ? 1 : -1, t = t > 0 ? 1 : -1, (k.x !== e || k.y !== t) && (k.x = e, k.y = t, M = [], C = 0)
        }

        function f(e) {
          if (e) {
            e = Math.abs(e), D.push(e), D.shift(), clearTimeout(A);
            var t = D[0] == D[1] && D[1] == D[2],
              o = h(D[0], 120) && h(D[1], 120) && h(D[2], 120);
            return !(t || o)
          }
        }

        function h(e, t) {
          return Math.floor(e / t) == e / t
        }

        function m(e) {
          var t, o, n;
          return e *= v.pulseScale, 1 > e ? t = e - (1 - Math.exp(-e)) : (o = Math.exp(-1), e -= 1, n = 1 - Math.exp(-e), t = o + n * (1 - o)), t * v.pulseNormalize
        }

        function p(e) {
          return e >= 1 ? 1 : 0 >= e ? 0 : (1 == v.pulseNormalize && (v.pulseNormalize /= m(1)), m(e))
        }

        var settings = $.extend({
          // These are the defaults.
          frameRate: 60,
          animationTime: 1000,
          stepSize: 120,
          pulseAlgorithm: !0,
          pulseScale: 8,
          pulseNormalize: 1,
          accelerationDelta: 20,
          accelerationMax: 1,
          keyboardSupport: !0,
          arrowScroll: 50,
          touchpadSupport: !0,
          fixedBackground: !0
        }, options);

        var w, g = {
            frameRate: settings.frameRate,
            animationTime: settings.animationTime,
            stepSize: settings.stepSize,
            pulseAlgorithm: settings.pulseAlgorithm,
            pulseScale: settings.pulseScale,
            pulseNormalize: settings.pulseNormalize,
            accelerationDelta: settings.accelerationDelta,
            accelerationMax: settings.accelerationMax,
            keyboardSupport: settings.keyboardSupport,
            arrowScroll: settings.arrowScroll,
            touchpadSupport: settings.touchpadSupport,
            fixedBackground: settings.fixedBackground,
            excluded: ""
          },
          v = g,
          b = !1,
          y = !1,
          k = {
            x: 0,
            y: 0
          },
          x = !1,
          S = document.documentElement,
          D = [120, 120, 120],
          H = {
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            spacebar: 32,
            pageup: 33,
            pagedown: 34,
            end: 35,
            home: 36
          },
          v = g,
          M = [],
          T = !1,
          C = +new Date,
          z = {};
        setInterval(function() {
          z = {}
        }, 1e4);
        var A, N = function() {
            var e = 0;
            return function(t) {
              return t.uniqueID || (t.uniqueID = e++)
            }
          }(),
          E = function() {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || function(e, t, o) {
              window.setTimeout(e, o || 1e3 / 60)
            }
          }(),
          K = /chrome|iPad/i.test(window.navigator.userAgent),
          L = "onmousewheel" in document;
        L && K && (u("mousedown", a), u("mousewheel", n), u("load", t))
      }();
    }



    /************************************/
    /*           Math Height            */

 var _previousResizeWidth = -1,
        _updateTimeout = -1;

    /*
    *  _parse
    *  value parse utility function
    */

    var _parse = function(value) {
        // parse value and convert NaN to 0
        return parseFloat(value) || 0;
    };

    /*
    *  _rows
    *  utility function returns array of jQuery selections representing each row
    *  (as displayed after float wrapping applied by browser)
    */

    var _rows = function(elements) {
        var tolerance = 1,
            $elements = $(elements),
            lastTop = null,
            rows = [];

        // group elements by their top position
        $elements.each(function(){
            var $that = $(this),
                top = $that.offset().top - _parse($that.css('margin-top')),
                lastRow = rows.length > 0 ? rows[rows.length - 1] : null;

            if (lastRow === null) {
                // first item on the row, so just push it
                rows.push($that);
            } else {
                // if the row top is the same, add to the row group
                if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
                    rows[rows.length - 1] = lastRow.add($that);
                } else {
                    // otherwise start a new row group
                    rows.push($that);
                }
            }

            // keep track of the last row top
            lastTop = top;
        });

        return rows;
    };

    /*
    *  _parseOptions
    *  handle plugin options
    */

    var _parseOptions = function(options) {
        var opts = {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        };

        if (typeof options === 'object') {
            return $.extend(opts, options);
        }

        if (typeof options === 'boolean') {
            opts.byRow = options;
        } else if (options === 'remove') {
            opts.remove = true;
        }

        return opts;
    };

    /*
    *  matchHeight
    *  plugin definition
    */

    var matchHeight = $.fn.matchHeight = function(options) {
        var opts = _parseOptions(options);

        // handle remove
        if (opts.remove) {
            var that = this;

            // remove fixed height from all selected elements
            this.css(opts.property, '');

            // remove selected elements from all groups
            $.each(matchHeight._groups, function(key, group) {
                group.elements = group.elements.not(that);
            });

            // TODO: cleanup empty groups

            return this;
        }

        if (this.length <= 1 && !opts.target) {
            return this;
        }

        // keep track of this group so we can re-apply later on load and resize events
        matchHeight._groups.push({
            elements: this,
            options: opts
        });

        // match each element's height to the tallest element in the selection
        matchHeight._apply(this, opts);

        return this;
    };

    /*
    *  plugin global options
    */

    matchHeight.version = '0.7.2';
    matchHeight._groups = [];
    matchHeight._throttle = 80;
    matchHeight._maintainScroll = false;
    matchHeight._beforeUpdate = null;
    matchHeight._afterUpdate = null;
    matchHeight._rows = _rows;
    matchHeight._parse = _parse;
    matchHeight._parseOptions = _parseOptions;

    /*
    *  matchHeight._apply
    *  apply matchHeight to given elements
    */

    matchHeight._apply = function(elements, options) {
        var opts = _parseOptions(options),
            $elements = $(elements),
            rows = [$elements];

        // take note of scroll position
        var scrollTop = $(window).scrollTop(),
            htmlHeight = $('html').outerHeight(true);

        // get hidden parents
        var $hiddenParents = $elements.parents().filter(':hidden');

        // cache the original inline style
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.data('style-cache', $that.attr('style'));
        });

        // temporarily must force hidden parents visible
        $hiddenParents.css('display', 'block');

        // get rows if using byRow, otherwise assume one row
        if (opts.byRow && !opts.target) {

            // must first force an arbitrary equal height so floating elements break evenly
            $elements.each(function() {
                var $that = $(this),
                    display = $that.css('display');

                // temporarily force a usable display value
                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                    display = 'block';
                }

                // cache the original inline style
                $that.data('style-cache', $that.attr('style'));

                $that.css({
                    'display': display,
                    'padding-top': '0',
                    'padding-bottom': '0',
                    'margin-top': '0',
                    'margin-bottom': '0',
                    'border-top-width': '0',
                    'border-bottom-width': '0',
                    'height': '100px',
                    'overflow': 'hidden'
                });
            });

            // get the array of rows (based on element top position)
            rows = _rows($elements);

            // revert original inline styles
            $elements.each(function() {
                var $that = $(this);
                $that.attr('style', $that.data('style-cache') || '');
            });
        }

        $.each(rows, function(key, row) {
            var $row = $(row),
                targetHeight = 0;

            if (!opts.target) {
                // skip apply to rows with only one item
                if (opts.byRow && $row.length <= 1) {
                    $row.css(opts.property, '');
                    return;
                }

                // iterate the row and find the max height
                $row.each(function(){
                    var $that = $(this),
                        style = $that.attr('style'),
                        display = $that.css('display');

                    // temporarily force a usable display value
                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                        display = 'block';
                    }

                    // ensure we get the correct actual height (and not a previously set height value)
                    var css = { 'display': display };
                    css[opts.property] = '';
                    $that.css(css);

                    // find the max height (including padding, but not margin)
                    if ($that.outerHeight(false) > targetHeight) {
                        targetHeight = $that.outerHeight(false);
                    }

                    // revert styles
                    if (style) {
                        $that.attr('style', style);
                    } else {
                        $that.css('display', '');
                    }
                });
            } else {
                // if target set, use the height of the target element
                targetHeight = opts.target.outerHeight(false);
            }

            // iterate the row and apply the height to all elements
            $row.each(function(){
                var $that = $(this),
                    verticalPadding = 0;

                // don't apply to a target
                if (opts.target && $that.is(opts.target)) {
                    return;
                }

                // handle padding and border correctly (required when not using border-box)
                if ($that.css('box-sizing') !== 'border-box') {
                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
                }

                // set the height (accounting for padding and border)
                $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
            });
        });

        // revert hidden parents
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.attr('style', $that.data('style-cache') || null);
        });

        // restore scroll position if enabled
        if (matchHeight._maintainScroll) {
            $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
        }

        return this;
    };

    /*
    *  matchHeight._applyDataApi
    *  applies matchHeight to all elements with a data-match-height attribute
    */

    matchHeight._applyDataApi = function() {
        var groups = {};

        // generate groups by their groupId set by elements using data-match-height
        $('[data-match-height], [data-mh]').each(function() {
            var $this = $(this),
                groupId = $this.attr('data-mh') || $this.attr('data-match-height');

            if (groupId in groups) {
                groups[groupId] = groups[groupId].add($this);
            } else {
                groups[groupId] = $this;
            }
        });

        // apply matchHeight to each group
        $.each(groups, function() {
            this.matchHeight(true);
        });
    };

    /*
    *  matchHeight._update
    *  updates matchHeight on all current groups with their correct options
    */

    var _update = function(event) {
        if (matchHeight._beforeUpdate) {
            matchHeight._beforeUpdate(event, matchHeight._groups);
        }

        $.each(matchHeight._groups, function() {
            matchHeight._apply(this.elements, this.options);
        });

        if (matchHeight._afterUpdate) {
            matchHeight._afterUpdate(event, matchHeight._groups);
        }
    };

    matchHeight._update = function(throttle, event) {
        // prevent update if fired from a resize event
        // where the viewport width hasn't actually changed
        // fixes an event looping bug in IE8
        if (event && event.type === 'resize') {
            var windowWidth = $(window).width();
            if (windowWidth === _previousResizeWidth) {
                return;
            }
            _previousResizeWidth = windowWidth;
        }

        // throttle updates
        if (!throttle) {
            _update(event);
        } else if (_updateTimeout === -1) {
            _updateTimeout = setTimeout(function() {
                _update(event);
                _updateTimeout = -1;
            }, matchHeight._throttle);
        }
    };

    /*
    *  bind events
    */

    // apply on DOM ready event
    $(matchHeight._applyDataApi);

    // use on or bind where supported
    var on = $.fn.on ? 'on' : 'bind';

    // update heights on load and resize events
    $(window)[on]('load', function(event) {
        matchHeight._update(false, event);
    });

    // throttled update heights on resize events
    $(window)[on]('resize orientationchange', function(event) {
        matchHeight._update(true, event);
    });



    /************************************/
    /*      Flex vertical Align        */
    

  $.fn.flexVerticalCenter = function( options ) {
    var settings = $.extend({
      cssAttribute:   'margin-top', // the attribute to apply the calculated value to
      verticalOffset: 0,            // the number of pixels to offset the vertical alignment by
      parentSelector: null,         // a selector representing the parent to vertically center this element within
      debounceTimeout: 25,          // a default debounce timeout in milliseconds
      deferTilWindowLoad: false     // if true, nothing will take effect until the $(window).load event
    }, options || {});

    return this.each(function(){
      var $this   = $(this); // store the object
      var debounce;

      // recalculate the distance to the top of the element to keep it centered
      var resizer = function () {

        var parentHeight = (settings.parentSelector && $this.parents(settings.parentSelector).length) ?
          $this.parents(settings.parentSelector).first().height() : $this.parent().height();

        $this.css(
          settings.cssAttribute, ( ( ( parentHeight - $this.height() ) / 2 ) + parseInt(settings.verticalOffset) )
        );
        if (settings.complete !== undefined) {
         settings.complete();
        }
      };

      // Call on resize. Opera debounces their resize by default.
      $(window).resize(function () {
          clearTimeout(debounce);
          debounce = setTimeout(resizer, settings.debounceTimeout);
      });

      if (!settings.deferTilWindowLoad) {
        // call it once, immediately.
        resizer();
      }

      // Call again to set after window (frames, images, etc) loads.
      $(window).on('load', function () {
          resizer();
      });

    });

  };



    $(document).on('click', 'a[href^="#"]', function (event) {
          event.preventDefault();


          var cp = $(document).scrollTop();
          var tosp = $($.attr(this, 'href')).offset().top;
          var animtime = Math.round(Math.abs(cp - tosp)/3000) * 1000;
          var animtime = (animtime < 1)? 500: animtime;


          $('html, body').animate({
              scrollTop: tosp
          }, animtime);
    });



    $("html").easeScroll({
      frameRate: 25,
      animationTime: 1500,
      stepSize: 80
    });
    $('.parallax-background').paroller();


    $('.matchHeight').matchHeight();
    $(".centerAlign").flexVerticalCenter();


      $('#accordion').find('.accordion-toggle').click(function(){
            //Expand or collapse this panel
            $(this).next().slideToggle('fast');
            //Hide the other panels
            $(".accordion-content").not($(this).next()).slideUp('fast');
      });


  },
  updated(){

      console.log('updated');
          $('.matchHeight').matchHeight();
          $(".centerAlign").flexVerticalCenter();

          $('.parallax-background').paroller();


          $('.accordion-toggle').unbind('click');
          $('#accordion').find('.accordion-toggle').click(function(){
                //Expand or collapse this panel
                $(this).next().slideToggle('fast');
                //Hide the other panels
                $(".accordion-content").not($(this).next()).slideUp('fast');
          });

      var UpdateTriggered = 1;

    
      
  }
}
</script>
<style lang="scss">
  @import './assets/styles/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue